import { Badge, Box, ListItem, ListItemText, Typography } from "@mui/material"

const StatusBadge = (color: string) => ({count}: {count: number | undefined}) => (
  <ListItem
    disableGutters
    sx={{
      pb: 2,
      pt: 0,
      pl: 2,
    }}
  >
    <ListItemText
      disableTypography
      primary={(
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Badge
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            variant="dot"
            sx={{
              pl: '20px',
              '& .MuiBadge-badge': {
                backgroundColor: color,
                left: 6,
                top: 11,
                width: 12,
                height: 12,
                borderRadius: '50%',
              }
            }}
          >
            <Typography
              color="textPrimary"
              variant="subtitle2"
            >
              {count}
            </Typography>
          </Badge>
        </Box>
      )}
    />
  </ListItem>
)

export const GreenJobs = StatusBadge('#288A1D')
export const YellowJobs = StatusBadge('#CF7706')
export const RedJobs = StatusBadge('#C24444')
